import { PropsWithChildren, ReactElement } from 'react';
import { PressableProps, ViewStyle } from 'react-native';
import { Styles } from '../../types/styles';
import { BoxProps } from '../Box/Box.types';
import { IconProps } from '../Icon/Icon.types';
import { TextProps } from '../Text/Text.types';

export type ButtonVariants = 'primary' | 'secondary' | 'tertiary';

export enum ButtonSizes {
  inline = 'inline',
  small = 'small',
  large = 'large',
}

export type ButtonProps = Styles<ViewStyle> &
  Pick<PressableProps, 'onPress'> &
  PropsWithChildren<{
    variant?: `${ButtonVariants}`;
    size?: `${ButtonSizes}`;
    light?: boolean;
    text?: string;
    locKey?: TextProps['locKey'];
    locNS?: TextProps['locNS'];
    loading?: boolean;
    disabled?: boolean;
    leftIcon?: IconProps['name'];
    rightIcon?: IconProps['name'];
    renderLeftIcon?: () => ReactElement;
    renderRightIcon?: () => ReactElement;
    trackingId?: string;
    /**
     * Optional styling overrides for the internal label Text.
     * Use this to avoid passing a custom Text as children just to style label.
     * locKey/locNS should still be provided via Button props when needed.
     */
    labelProps?: Partial<
      Pick<
        TextProps,
        | 'variant'
        | 'uppercase'
        | 'animatedStyle'
        | 'textAlign'
        | 'numberOfLines'
        | 'wordBreak'
        | 'underline'
        | 'crossedOut'
        | 'color'
        | 'gradient'
      >
    >;
  }>;

export type SizesConfig = Record<
  ButtonSizes,
  Pick<BoxProps, 'width' | 'height' | 'paddingHorizontal' | 'gap'>
>;
